module.exports = __webpack_public_path__ + "img/productEditor.b4b52160.jpg";